import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
//import 'bootstrap/dist/css/bootstrap.min.css';
import * as serviceWorker from './serviceWorker';


//Browser router
//import { BrowserRouter } from 'react-router-dom';

ReactDOM.render(<App />,document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
